import React, { createContext, useContext, useMemo } from "react";

export type ModalSkeletonSurface = "dialog" | "sidebar";

interface ModalSkeletonContextValue {
  insideModal: boolean;
  surface: ModalSkeletonSurface;
}

const ModalSkeletonContext = createContext<ModalSkeletonContextValue>({
  insideModal: false,
  surface: "dialog",
});

/**
 * Marca a subárvore como conteúdo de modal. O Loading usa isso para trocar o
 * skeleton de página (SkeletonTable) pelo SkeletonModal, sem que os corpos de
 * modal precisem saber onde estão montados.
 */
export const ModalSkeletonProvider: React.FC<{
  surface?: ModalSkeletonSurface;
  children: React.ReactNode;
}> = ({ surface = "dialog", children }) => {
  const value = useMemo(
    () => ({ insideModal: true, surface }),
    [surface]
  );

  return (
    <ModalSkeletonContext.Provider value={value}>
      {children}
    </ModalSkeletonContext.Provider>
  );
};

export const useModalSkeleton = () => useContext(ModalSkeletonContext);
